import { render, staticRenderFns } from "./ModalConfirmacao.vue?vue&type=template&id=fea2ab3a&scoped=true"
import script from "./ModalConfirmacao.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirmacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalConfirmacao.vue?vue&type=style&index=0&id=fea2ab3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea2ab3a",
  null
  
)

export default component.exports